export const renderFooter = (targetSelector = "#footer-root", config = null) => {
  const target = document.querySelector(targetSelector);
  if (!target) return;

  const businessName = config?.businessName || "Pizzeria ";
  const whatsappPhone = config?.whatsappPhone || "5491144447788";
  const phone = config?.phone || "011 4555-9898";
  const ubicacion = config?.ubicacion || config?.address || "Av. Corrientes 4567, CABA";
  const horarios = config?.horarios || "Abiertos todos los dias";

  const whatsappLink = whatsappPhone.replace(/\D/g, "");
  const phoneLink = phone.replace(/\D/g, "");

  target.innerHTML = `
    <footer class="site-footer">
      <div class="container footer__inner">
        <div>
          <h3>Contacto rapido</h3>
          <address class="footer__address">
            ${
              whatsappPhone
                ? `
              <p>
                WhatsApp
                <a href="https://wa.me/${whatsappLink}" aria-label="WhatsApp">${whatsappPhone}</a>
              </p>
            `
                : ""
            }
            ${
              phone
                ? `
              <p>
                Telefono
                <a href="tel:${phoneLink}" aria-label="Telefono">${phone}</a>
              </p>
            `
                : ""
            }
          </address>
        </div>
        <div>
          <h3>Seguinos</h3>
          <div class="footer__socials">
            <a href="https://www.instagram.com/fakipizzas" aria-label="Instagram" target="_blank">Instagram</a>
            <a href="https://www.tiktok.com/@fakipizzas" aria-label="TikTok" target="_blank">TikTok</a>
          </div>
        </div>
        <div>
          <h3>Direccion</h3>
          <address class="footer__address">
            <p>${ubicacion}</p>
            <p>${horarios}</p>
          </address>
        </div>
      </div>
      <div class="footer__bottom">
        <small>(c) ${new Date().getFullYear()} ${businessName}. Todos los derechos reservados.</small>
      </div>
    </footer>
  `;
};
